import { LuCopy } from 'react-icons/lu';
import { IconButton } from '../../../../components/IconButton';
import { Code, Container } from './styles';

interface Props {
    codeText: string;
}

export default function CopyCode({ codeText }: Props) {
    function handleCopyCode() {
        navigator.clipboard.writeText(codeText);
    }

    return (
        <Container>
            <Code>{codeText}</Code>
            <IconButton className="copy-button" onClick={handleCopyCode}>
                <LuCopy color="#32BCAD" />
            </IconButton>
        </Container>
    );
}
